import { createStore, createHook } from 'react-sweet-state';
import { INITIAL_UI_STATE } from '../../common/constants/state';
import type { UIState } from '../../common/types';
import { type Actions, actions } from './actions';

export const Store = createStore<UIState, Actions>({
	initialState: INITIAL_UI_STATE,
	actions,
	name: 'ProjectCreateImporterUIStore',
});

export const useUIState = createHook(Store);
